import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { useAccountStore } from '@/store/modules/account'
import MitteeWebIns from '@/vendors/miitee-sdk'
import { MiiteeEventTypeEnum } from 'miitee-web-sdk-beta/common/enums'
import { removeUsig, setUsig } from '@/utils/is'
import { useNetwork } from '@vueuse/core'
import { reportTraceRoutes } from '@/api/report'
import { getMiiteeToken } from '@/utils/auth'
import useMiiteeReport from './useReport'
import { reportTypeEnum } from '../../types/report'
enum NotReadyReason {
  kicked_out = 0,
  logout = 1,
  token_expired = 2,
}


export default /*#__PURE__*/_defineComponent({
  name: 'Entrance',
  setup(__props) {

const { isOnline } = useNetwork()

const router = useRouter()
const accountStore = useAccountStore()

watch(
  () => router,
  (newval, oldval) => {
    console.log('newval is : ', newval, 'oldval is : ', oldval)
  }
)

watch(isOnline, async (n, o) => {
  if (n && !o) {
    reportTraceRoutes(getMiiteeToken())
  }
})

const reportOpenApp = () => {
  try {
    useMiiteeReport.report([{
      event: 'open_app',
      data: {}
    }], reportTypeEnum.BehaviorAnalysis)
  } catch (error) {
    console.error('reportOpenApp error: ', error)
  } finally {
    window['_openApp'] = false
  }
}

const sdkReadyHandler = async (event) => {
  await setUsig(event.detail?.usig)
  reportTraceRoutes(getMiiteeToken())
  const userVal = await MitteeWebIns.Profile.getUserProfileInfo()
  accountStore.updateUserInfo(userVal)
  const accountRes = MitteeWebIns.getAccount()
  accountStore.updateAccount(accountRes)
  const { nickname, uid, did, platform } = accountRes
  accountStore.updateSdkStatu(true)
  if (window['_openApp']) {
    reportOpenApp()
  }
  MitteeWebIns.TIM.IM.addMessageReceivedListener((event) => {
    // console.log('sdk TIM message:...............', event)
  })
  // @ts-ignore
  MitteeWebIns.TIM.Signaling.addSignalingListener({
    onReceiveNewInvitation: (
      inviteID,
      inviter,
      groupID,
      inviteeList,
      data
    ) => {},
  })

  // @ts-ignore
  MitteeWebIns.TIM.Signaling.addSignalingListener({
    onInvitationCancelled: (inviteID, inviter, data) => {},
  })
}

const sdkNotReadyHandler = (event) => {
  // 退出登录相关
  console.log('sdkNotReady event:\\\\', event)
  const { reason } = event.detail
  console.log('sdknotready reson: ', reason)
  // @ts-ignore
  if (NotReadyReason[reason] === NotReadyReason.kicked_out) {
    accountStore.updateUserInfo(null)
    accountStore.updateAccount(null)
    removeUsig()
    message.warn('您的账号已在其他地方登录！')
    router.replace({
      path: '/',
    })
  }
  // @ts-ignore
  if (NotReadyReason[reason] === NotReadyReason.logout) {
    accountStore.updateUserInfo(null)
    accountStore.updateAccount(null)
    removeUsig()
    location.reload()
  }
  // @ts-ignore
  if (NotReadyReason[reason] === NotReadyReason.token_expired) {
    accountStore.updateUserInfo(null)
    accountStore.updateAccount(null)
    removeUsig()
    location.reload()
  }
  accountStore.updateSdkStatu(false)
}

onMounted(() => {
  MitteeWebIns.on(MiiteeEventTypeEnum.sdkReady, sdkReadyHandler)
  MitteeWebIns.on(MiiteeEventTypeEnum.sdkNotReady, sdkNotReadyHandler)
})

onUnmounted(() => {
  MitteeWebIns.off(MiiteeEventTypeEnum.sdkReady, sdkReadyHandler)
  MitteeWebIns.off(MiiteeEventTypeEnum.sdkNotReady, sdkNotReadyHandler)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})